"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logging = _interopRequireDefault(require("logging"));

var _eccrypto = _interopRequireDefault(require("eccrypto"));

var _ethereumjsUtil = _interopRequireDefault(require("ethereumjs-util"));

var _crypto = _interopRequireDefault(require("crypto"));

var _secp256k = _interopRequireDefault(require("secp256k1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var logger = (0, _logging.default)('MewCrypto');

var MewConnectCrypto = /*#__PURE__*/function () {
  function MewConnectCrypto() {
    _classCallCheck(this, MewConnectCrypto);
  }

  _createClass(MewConnectCrypto, [{
    key: "setPrivate",
    value: function setPrivate(pvtKey) {
      this.prvt = Buffer.from(pvtKey, 'hex');
      this.pub = this.generatePublic(this.prvt);
      return {
        publicKey: this.pub,
        privateKey: this.prvt
      };
    }
  }, {
    key: "generateMessage",
    value: function generateMessage() {
      return _crypto.default.randomBytes(32).toString('hex');
    } // Not for the Address, but generate them for the connection check

  }, {
    key: "prepareKey",
    value: function prepareKey() {
      this.prvt = this.generatePrivate();
      this.pub = this.generatePublic(this.prvt);
      return {
        pub: this.pub,
        pvt: this.prvt
      };
    }
  }, {
    key: "generateKeys",
    value: function generateKeys() {
      this.prvt = this.generatePrivate();
      this.pub = this.generatePublic(this.prvt);
      return {
        publicKey: this.pub,
        privateKey: this.prvt
      };
    }
  }, {
    key: "generatePrivate",
    value: function generatePrivate() {
      var privKey;

      do {
        privKey = _crypto.default.randomBytes(32);
      } while (!_secp256k.default.privateKeyVerify(privKey));

      return privKey;
    }
  }, {
    key: "generatePublic",
    value: function generatePublic(privKey) {
      var pvt = Buffer.from(privKey, 'hex');
      this.prvt = pvt;
      return _secp256k.default.publicKeyCreate(pvt);
    }
  }, {
    key: "encrypt",
    value: function encrypt(dataToSend) {
      var publicKeyA = _eccrypto.default.getPublic(this.prvt);

      return new Promise(function (resolve, reject) {
        _eccrypto.default.encrypt(publicKeyA, Buffer.from(dataToSend)).then(function (_initial) {
          resolve(_initial);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "decrypt",
    value: function decrypt(dataToSee) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _eccrypto.default.decrypt(_this.prvt, {
          ciphertext: Buffer.from(dataToSee.ciphertext),
          ephemPublicKey: Buffer.from(dataToSee.ephemPublicKey),
          iv: Buffer.from(dataToSee.iv),
          mac: Buffer.from(dataToSee.mac)
        }).then(function (_initial) {
          var result;

          try {
            if (_this.isJSON(_initial)) {
              var humanRadable = JSON.parse(_initial);

              if (Array.isArray(humanRadable)) {
                result = humanRadable[0];
              } else {
                result = humanRadable;
              }
            } else {
              result = _initial.toString();
            }
          } catch (e) {
            logger.error(e);
          }

          resolve(JSON.stringify(result));
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "signMessage",
    value: function signMessage(msgToSign) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          var msg = _ethereumjsUtil.default.hashPersonalMessage(_ethereumjsUtil.default.toBuffer(msgToSign));

          var signed = _ethereumjsUtil.default.ecsign(Buffer.from(msg), Buffer.from(_this2.prvt, 'hex'));

          var combined = Buffer.concat([Buffer.from([signed.v]), Buffer.from(signed.r), Buffer.from(signed.s)]);
          var combinedHex = combined.toString('hex');
          resolve(combinedHex);
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "signMessageSync",
    value: function signMessageSync(msgToSign) {
      msgToSign = this.bufferToString(msgToSign);

      var msg = _ethereumjsUtil.default.hashPersonalMessage(_ethereumjsUtil.default.toBuffer(msgToSign));

      var signed = _ethereumjsUtil.default.ecsign(Buffer.from(msg), Buffer.from(this.prvt, 'hex'));

      var combined = Buffer.concat([Buffer.from([signed.v]), Buffer.from(signed.r), Buffer.from(signed.s)]);
      return combined.toString('hex');
    }
  }, {
    key: "bufferToConnId",
    value: function bufferToConnId(buf) {
      return buf.toString('hex').slice(0, 32);
    }
  }, {
    key: "generateConnId",
    value: function generateConnId(buf) {
      if (buf instanceof Buffer) {
        return buf.toString('hex').slice(0, 32);
      }

      return Buffer.from(buf).toString('hex').slice(0, 32);
    }
  }, {
    key: "isJSON",
    value: function isJSON(arg) {
      try {
        JSON.parse(arg);
        return true;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "toBuffer",
    value: function toBuffer(buf) {
      if (buf instanceof Buffer) {
        return buf;
      }

      return Buffer.from(buf, 'hex');
    }
  }, {
    key: "bufferToString",
    value: function bufferToString(buf) {
      if (buf instanceof Buffer) {
        return buf.toString('hex');
      }

      return buf;
    }
  }], [{
    key: "create",
    value: function create() {
      return new MewConnectCrypto();
    }
  }]);

  return MewConnectCrypto;
}();

exports.default = MewConnectCrypto;